import {AiVideoAudio, AiVideoQuality} from '@Panels/ai-video-panel/ai-video-panel.types';

export interface AiPosterAnimationPanelProps {
  onAnimationAddedToDesign?: () => void;
  isModal?: boolean;
  onClose?: () => void;
  isPromptMode?: boolean;
  onPromptModeChange?: (isPromptMode: boolean) => void;
}

export const DEFAULT_POSTER_ANIMATION_QUALITY = AiVideoQuality.HD;

export const DEFAULT_POSTER_ANIMATION_AUDIO = AiVideoAudio.YES;

export const POSTER_ANIMATION_OVERLAY_ASSET = 'turn-into-video-panel-preview.webm';

export const POSTER_ANIMATION_PROMPT_BOX_ID = 'poster-animation-prompt-box';

export const PREFERENCES_POPUP_MAX_WIDTH = 276;

export const PREFERENCES_POPUP_CONTENT_CLASS = 'spacing-p-b-4';

export const PREFERENCES_MODAL_CONTENT_CLASS = 'spacing-p-t-3 spacing-p-b-8';

export const POSTER_ANIMATION_SKELETON_ID_PREFIX = 'poster-animation-loading-skeleton-';

export const POSTER_ANIMATION_GENERATION_LOADING_KEY = 'poster-animation-generation';

export const POSTER_ANIMATION_READY_LOADING_KEY = 'poster-animation-ready';

export const POSTER_ANIMATION_READY_TOAST_DURATION_MS = 10000;

export const PROMPT_BOX_LOADING_RESET_MS = 1000;

export const MAX_CONCURRENT_POSTER_ANIMATIONS = 10;

export const HIDE_FINALIZE_HINT_AT_GENERATION_COUNT = 5;
